import template from './region-detail.html';
import controller from './region-detail.controller';

let regionDetailComponent = {
  bindings: {},
  template,
  controller
};

export default regionDetailComponent;



// WEBPACK FOOTER //
// ./client/app/components/region/region-detail.component.js